import {
  Alert as ChakraAlert,
  AlertIcon,
  AlertDescription,
  Box,
} from '@chakra-ui/react';
import type { AlertProps } from '@chakra-ui/react';
import React from 'react';

// Exports
type ActionableAlertProps = { actionElement: React.ReactElement } & AlertProps;
export const ActionableAlert = ({
  actionElement,
  status,
  variant,
  borderRadius,
  ...alertProps
}: ActionableAlertProps) => {
  return (
    <ChakraAlert
      {...alertProps}
      status={status}
      variant={variant || 'subtle'}
      borderRadius={borderRadius || '10px'}
    >
      <AlertIcon />
      <AlertDescription>{alertProps.children}</AlertDescription>
      <Box flexGrow={1} textAlign="right">
        {actionElement}
      </Box>
    </ChakraAlert>
  );
};
